import {
    MYALERTS_SUBSCRIBE_SUCCESS,
    MYALERTS_SUBSCRIBE_ERROR,
    MYALERTS_CLEAR_DATA,
    MYALERTS_LOADER,
} from '../actionTypes/MyAlertsActionTypes';

const myAlertsReducer = function MyAlertsReducer(state = {}, action) {
    switch (action.type) {
        case MYALERTS_SUBSCRIBE_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        case MYALERTS_SUBSCRIBE_ERROR:
            return {
                ...state,
                ...action.payload,
            };
        case MYALERTS_LOADER:
            return {
                ...state,
                ...action.payload,
            };
        case MYALERTS_CLEAR_DATA:
            return {
                ...action.payload,
            };
        default:
            return state;
    }
};

myAlertsReducer.reducerName = 'myAlerts';

export default myAlertsReducer;
